import type {CancellationDataService} from '../../../loan/cancellation.data-service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';
import type {Loan} from 'typings/portaro.be.types';

export class SearchedLoansService {
    public static serviceName = 'searchedLoansService';

    /*@ngInject*/
    constructor(private cancellationDataService: CancellationDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }


    public async cancelLoan(loan: Loan) {
        try {
            const response = await this.cancellationDataService.cancelLoan(loan);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(response);
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
        }
    };
}